<template>
    <div class="loading-container">
        <div class="loading-spinner">
            <div class="spinner"></div>
            <p>Chargement de l'application...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingApp'
}
</script>

<style scoped>
.loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-spinner {
    text-align: center;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #e3e3e3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

p {
    color: #666;
    font-size: 16px;
    margin: 0;
}
</style> 